import { NgZone } from '@angular/core';
import { Auth, User, onAuthStateChanged } from 'firebase/auth';
import { Observable } from 'rxjs';
import { observeInZone } from './ZoneUtils';

/**
 * RxJS over Firebase Auth's callback listener, replacing @angular/fire's
 * AngularFireAuth.authState.
 *
 * Emits null when signed out and the User when signed in, starting with the resolved
 * state rather than the seeded one. The guards depend on that: on a full page load the
 * AuthService subjects are still false, which used to bounce signed-in members off
 * /reserveer and /mijn-reservaties on refresh or a deep link.
 *
 * Zone re-entry is applied here. The compat stream this replaces re-entered the zone on
 * its own, so leaving it out would resolve guards outside Angular and skip the
 * change-detection pass that renders the routed page.
 *
 * Does not complete; unsubscribing detaches the listener.
 */
export function authState$(auth: Auth, zone: NgZone): Observable<User | null> {
  return new Observable<User | null>((subscriber) =>
    onAuthStateChanged(
      auth,
      (user) => subscriber.next(user),
      (error) => subscriber.error(error),
    ),
  ).pipe(observeInZone(zone));
}
